import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { environment } from '@base/environments/environment';
import { DashboardGuard } from './core/dashboard.guard';
import { PostLoginRedirectGuard } from './core/post-login-redirect.guard';
import { RootRedirectGuard } from './core/root-redirect.guard';
import { PanelLayoutComponent } from './layouts/panel-layout/panel-layout.component';
import { PrivateLayoutComponent } from './layouts/private-layout/private-layout.component';

export function learningMatcher(segments: UrlSegment[]) {
  const FULL_URL = segments.map((s) => s.path).join('/');
  return FULL_URL.includes('learning') ? { consumed: segments } : null;
}

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [RootRedirectGuard],
    children: [],
  },
  {
    path: 'home',
    component: PrivateLayoutComponent,
    canActivate: [PostLoginRedirectGuard],
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'ranking',
    data: { authorizedRoles: environment.routeAuthorization.ranking },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/ranking/ranking.module').then((m) => m.RankingModule),
  },
  {
    path: 'ranking-unificado',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/office-ranking/office-ranking.module').then(
        (m) => m.OfficeRankingModule,
      ),
  },
  {
    path: 'beta/recruitment',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/recruitment/recruitment.module').then(
        (m) => m.RecruitmentModule,
      ),
  },
  {
    path: 'renditions',
    data: { authorizedRoles: environment.routeAuthorization.ranking },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/renditions/rendition-panel/rendition-panel.module').then(
        (m) => m.RenditionPanelModule,
      ),
  },
  {
    path: 'renditions/pending-list',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/renditions/pending-list/pending-list.module').then(
        (m) => m.PendingListModule,
      ),
  },
  {
    path: 'renditions/pending-list/register/:id',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/renditions/rendition-form/rendition-form.module').then(
        (m) => m.RenditionFormModule,
      ),
  },
  {
    path: 'renditions/cuota/add/:id',
    data: { authorizedRoles: environment.routeAuthorization.ranking },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/renditions/rendition-form/rendition-form.module').then(
        (m) => m.RenditionFormModule,
      ),
  },
  {
    path: 'renditions/cuota/edit/:id',
    data: { authorizedRoles: environment.routeAuthorization.ranking },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/renditions/rendition-form/rendition-form.module').then(
        (m) => m.RenditionFormModule,
      ),
  },
  {
    path: 'renditions/ingreso-relacionado/add',
    data: { authorizedRoles: environment.routeAuthorization.ranking },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/renditions/rendition-form/rendition-form.module').then(
        (m) => m.RenditionFormModule,
      ),
  },
  {
    path: 'renditions/ingreso-relacionado/edit/:id',
    data: { authorizedRoles: environment.routeAuthorization.ranking },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/renditions/rendition-form/rendition-form.module').then(
        (m) => m.RenditionFormModule,
      ),
  },
  {
    path: 'renditions/referido-a-cobrar/add',
    data: { authorizedRoles: environment.routeAuthorization.ranking },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/renditions/rendition-form/rendition-form.module').then(
        (m) => m.RenditionFormModule,
      ),
  },
  {
    path: 'renditions/referido-a-cobrar/edit/:id',
    data: { authorizedRoles: environment.routeAuthorization.ranking },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/renditions/rendition-form/rendition-form.module').then(
        (m) => m.RenditionFormModule,
      ),
  },
  {
    path: 'renditions/reserve/:id',
    data: { authorizedRoles: environment.routeAuthorization.ranking },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/renditions/rendition-form/rendition-form.module').then(
        (m) => m.RenditionFormModule,
      ),
  },
  {
    path: 'renditions/add',
    data: { authorizedRoles: environment.routeAuthorization.ranking },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/renditions/rendition-form/rendition-form.module').then(
        (m) => m.RenditionFormModule,
      ),
  },
  {
    path: 'renditions/edit/:id',
    data: { authorizedRoles: environment.routeAuthorization.ranking },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/renditions/rendition-form/rendition-form.module').then(
        (m) => m.RenditionFormModule,
      ),
  },
  {
    path: 'renditions/drafts',
    data: { authorizedRoles: environment.routeAuthorization.ranking },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/renditions/rendition-drafts/rendition-drafts.module').then(
        (m) => m.RenditionDraftsModule,
      ),
  },
  {
    path: 'renditions/movements/:id',
    data: { authorizedRoles: environment.routeAuthorization.ranking },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/renditions/rendition-movements/rendition-movements.module').then(
        (m) => m.RenditionMovementsModule,
      ),
  },
  {
    path: 'renditions/preview/:id',
    data: { authorizedRoles: environment.routeAuthorization.ranking },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/renditions/rendition-preview/rendition-preview.module').then(
        (m) => m.RenditionPreviewModule,
      ),
  },
  {
    path: 'downloads',
    data: { authorizedRoles: environment.routeAuthorization.downloads },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/downloads/downloads.module').then(
        (m) => m.DownloadsModule,
      ),
  },
  {
    path: 'configuration',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/configuration/panel/configuration.module').then(
        (m) => m.ConfigurationModule,
      ),
  },
  {
    path: 'configuration/create-user',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/configuration/create-user-form/create-user-form.module').then(
        (m) => m.CreateUserFormModule,
      ),
  },
  {
    path: 'configuration/edit-user/:id',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/configuration/create-user-form/create-user-form.module').then(
        (m) => m.CreateUserFormModule,
      ),
  },
  {
    path: 'configuration/add-jurisdiction',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/configuration/add-jurisdiction-form/add-jurisdiction-form.module').then(
        (m) => m.AddJurisdictionFormModule,
      ),
  },
  {
    path: 'configuration/edit-jurisdiction/:id',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/configuration/add-jurisdiction-form/add-jurisdiction-form.module').then(
        (m) => m.AddJurisdictionFormModule,
      ),
  },
  {
    path: 'panel',
    data: {},
    component: PanelLayoutComponent,
    loadChildren: () =>
      import('./pages/panel/panel.module').then((m) => m.PanelModule),
  },
  {
    path: 'qrcomps',
    data: { authorizedRoles: environment.routeAuthorization.qrcomps },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/qrcomps/qrcomps.module').then((m) => m.QrcompsModule),
  },
  {
    path: 'billing',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/electronic-billing/electronic-billing-panel/electronic-billing-panel.module').then(
        (m) => m.ElectronicBillingPanelModule,
      ),
  },
  {
    path: 'billing/crear',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/electronic-billing/electronic-billing-form/electronic-billing-form.module').then(
        (m) => m.ElectronicBillingFormModule,
      ),
  },
  {
    path: 'dashboard',
    data: { authorizedRoles: environment.routeAuthorization.dashboard },
    component: PrivateLayoutComponent,
    canActivate: [DashboardGuard],
    loadChildren: () =>
      import('./pages/dashboard/dashboard.module').then(
        (m) => m.DashboardModule,
      ),
  },
  {
    path: 'rrhh',
    data: {
      authorizedRoles:
        environment.routeAuthorization
          .ranking /* PROVISORIO, CAMBIAR, PREGUNTAR 🤚⛔*/,
    },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/rrhh/rrhh.module').then((m) => m.RrhhModule),
  },
  {
    path: 'rrhh/create',
    data: {
      authorizedRoles:
        environment.routeAuthorization
          .ranking /* PROVISORIO, CAMBIAR, PREGUNTAR 🤚⛔*/,
    },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/rrhh/form/rrhh-form.module').then(
        (m) => m.RrhhFormModule,
      ),
  },
  {
    path: 'rrhh/edit/:id',
    data: {
      authorizedRoles:
        environment.routeAuthorization
          .ranking /* PROVISORIO, CAMBIAR, PREGUNTAR 🤚⛔*/,
    },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/rrhh/form/rrhh-form.module').then(
        (m) => m.RrhhFormModule,
      ),
  },
  {
    path: 'rrhh/candidate/:id',
    data: {
      authorizedRoles:
        environment.routeAuthorization
          .ranking /* PROVISORIO, CAMBIAR, PREGUNTAR 🤚⛔*/,
    },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/rrhh/form/rrhh-form.module').then(
        (m) => m.RrhhFormModule,
      ),
  },
  {
    path: 'rrhh/create-team',
    data: {
      authorizedRoles:
        environment.routeAuthorization
          .ranking /* PROVISORIO, CAMBIAR, PREGUNTAR 🤚⛔*/,
    },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/rrhh/form-team/form-team.module').then(
        (m) => m.RrhhFormTeamModule,
      ),
  },
  {
    path: 'rrhh/edit-team/:id',
    data: {
      authorizedRoles:
        environment.routeAuthorization
          .ranking /* PROVISORIO, CAMBIAR, PREGUNTAR 🤚⛔*/,
    },
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/rrhh/form-team/form-team.module').then(
        (m) => m.RrhhFormTeamModule,
      ),
  },
  {
    path: 'session-expired',
    loadChildren: () =>
      import('./pages/session-expired/session-expired.module').then(
        (m) => m.SessionExpiredModule,
      ),
  },
  {
    path: 'calendar',
    loadChildren: () =>
      import('./pages/renditions/rendition-drafts/rendition-drafts.module').then(
        (m) => m.RenditionDraftsModule,
      ),
  },
  {
    path: 'support',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/help-and-support/help-and-support.module').then(
        (m) => m.HelpAndSupportModule,
      ),
  },
  {
    path: 'recruitment',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/recruitment/recruitment.module').then(
        (m) => m.RecruitmentModule,
      ),
  },
  {
    path: 'nueva-captacion',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/listing-captured-form/listing-captured-form.module').then(
        (m) => m.ListingCapturedFormModule,
      ),
  },
  {
    path: 'nueva-captacion/:id',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/listing-captured-form/listing-captured-form.module').then(
        (m) => m.ListingCapturedFormModule,
      ),
  },
  {
    path: 'nueva-captacion/edit/:id',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/listing-captured-form/listing-captured-form.module').then(
        (m) => m.ListingCapturedFormModule,
      ),
  },
  {
    path: 'importador-de-captaciones',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/listings-importer/listings-importer.module').then(
        (m) => m.ListingsImporterModule,
      ),
  },
  {
    path: 'nueva-reserva',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/reservation-form/reservation-form.module').then(
        (m) => m.ReservationFormModule,
      ),
  },
  {
    path: 'listado',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/stats/stats-list/stats-list.module').then(
        (m) => m.StatsListModule,
      ),
  },
  {
    path: 'nueva-reserva/:id',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/reservation-form/reservation-form.module').then(
        (m) => m.ReservationFormModule,
      ),
  },
  //TODO: ↓↓ Eliminar luego de la migración de listado y reservómetro
  {
    path: 'editar-reserva/:id/:origin',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/reservation-form/reservation-form.module').then(
        (m) => m.ReservationFormModule,
      ),
  },
  {
    path: 'editar-reserva/:id',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/reservation-form/reservation-form.module').then(
        (m) => m.ReservationFormModule,
      ),
  },
  // {
  //   path: 'qr-ia',
  //   component: PrivateLayoutComponent,
  //   loadChildren: () =>
  //     import('./pages/ia-landing/ia-landing.module').then(
  //       (m) => m.IaLandingModule
  //     )
  // },
  {
    path: 'qr-ia',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/ia-landing/ia-landing.module').then(
        (m) => m.IaLandingModule,
      ),
  },
  {
    path: 'sync',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/property-manager/property-manager.module').then(
        (m) => m.PropertyManagerModule,
      ),
  },
  {
    path: 'importar-csv',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/csv-importer/csv-importer.module').then(
        (m) => m.CsvImporterModule,
      ),
  },
  {
    path: 'movimientos',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/movements/movements-panel.module').then(
        (m) => m.MovementsPanelModule,
      ),
  },
  {
    path: 'resumen-oficinas',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/stats/office-resume/office-resume.module').then(
        (m) => m.OfficeResumeModule,
      ),
  },
  {
    path: 'resumen-agentes',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/stats/agent-resume/agent-resume.module').then(
        (m) => m.AgentResumeModule,
      ),
  },
  {
    path: 'resumen-teams',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/stats/teams-resume/teams-resume.module').then(
        (m) => m.TeamsResumeModule,
      ),
  },
  {
    path: 'reservometro',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/stats/reservometro/reservometro.module').then(
        (m) => m.ReservometroModule,
      ),
  },
  {
    path: 'rrhh-stats',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/rrhh-stats/rrhh-stats.module').then(
        (m) => m.RrhhStatsModule,
      ),
  },
  {
    path: 'generador-xml-uif',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/xml-generator-uif/xml-generator-uif.module').then(
        (m) => m.XmlGeneratorUifModule,
      ),
  },
  {
    path: 'cuentas-corrientes',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/accounts/accounts.module').then((m) => m.AccountsModule),
  },
  {
    path: 'oculto-reportes-v2',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/expenses-and-profit/expenses-and-profit.module').then(
        (m) => m.ExpensesAndProfitModule,
      ),
  },
  {
    path: 'inteligencia-artificial',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/inteligencia-artificial/inteligencia-artificial.module').then(
        (m) => m.InteligenciaArtificialModule,
      ),
  },
  {
    path: 'reports',
    component: PrivateLayoutComponent,
    loadChildren: () =>
      import('./pages/expenses-and-profit/expenses-and-profit.module').then(
        (m) => m.ExpensesAndProfitModule,
      ),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginModule),
  },
  {
    matcher: learningMatcher,
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginModule),
  },

  { path: '**', redirectTo: 'home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
